// extracted by mini-css-extract-plugin
module.exports = {"DisasterPrevention":"DisasterPrevention_DisasterPrevention__SHCh2"};